import {Injectable, inject} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {map} from 'rxjs/operators';
import {plainToClass} from 'class-transformer';
import {Bookmark, Juntada, Tarefa, VinculacaoDocumento, Volume} from '@cdk/models';
import { VisualizadorTarefasContext } from 'app/main/apps/todas-tarefas/todas-tarefas.store';

@Injectable()
export class VisualizadorService {
    private http = inject(HttpClient);
    path: string;

    constructor() {
        this.path = 'administrativo/visualizador';
    }

    getArvoreJuntadas(processoId: number, context: any = '{}'): Observable<any> {
        const params: HttpParams = new HttpParams().set('context', context);
        return this.http.get(`${environment.api_url}${this.path}/juntadas/${processoId}` + environment.xdebug, {params}).pipe(
            map((response) => {
                response = plainToClass(Juntada, response);
                return response;
            })
        );
    }

    getArvoreBookmarks(processoId: number): Observable<any> {
        return this.http.get(`${environment.api_url}${this.path}/bookmarks/${processoId}` + environment.xdebug).pipe(
            map((response) => {
                response = plainToClass(Bookmark, response);
                return response;
            })
        );
    }

    getArvoreVinculacoesDocumentos(documentoId: number, context: any = '{}'): Observable<any> {
        const params: HttpParams = new HttpParams().set('context', context);
        return this.http.get(`${environment.api_url}${this.path}/vinculacoesDocumentos/${documentoId}` + environment.xdebug, {params}).pipe(
            map((response) => {
                response = plainToClass(VinculacaoDocumento, response);
                return response;
            })
        );
    }

    getArvoreVolumes(processoId: number): Observable<any> {
        return this.http.get(`${environment.api_url}${this.path}/volumes/${processoId}` + environment.xdebug).pipe(
            map((response) => {
                response = plainToClass(Volume, response);
                return response;
            })
        );
    }

    getTarefas(context: VisualizadorTarefasContext = {}): Observable<Tarefa[]> {
        const params: HttpParams = new HttpParams().set('context', JSON.stringify(context));

        return this.http.get<Tarefa[]>(`${environment.api_url}${this.path}/tarefas` + environment.xdebug, {params}).pipe(
            map((response) => {
                response = plainToClass(Tarefa, response);
                return response;
            })
        );
    }
}
